/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.membership.controllers', [
  'colorpicker.module',
  'acme.common.service.api',
  'acme.common.service.posConfig',
  'acme.common.factory.gridState'
])

.controller('PosCreatePagesFormsMembershipController', ['$scope', '$timeout', '$filter', 'ApiService', 'PosConfigService', 'GridStateFactory', function($scope, $timeout, $filter, ApiService, PosConfigService, GridStateFactory) {

    $scope.posCreatePagesFormsMembership = {

      queryTimer: false,

      model: [],
      list: [],

      title: '',
      subTitle: '',
      color: '',
      selected: '',
      showIcon: false,
      reduceList: false,
      isLoaded: false,
      colorCodes: {
        textColor: '',
        backgroundColor: ''
      },

      spectrumConfig: {
        titleText: 'Tile color'
      },
      gridState: new GridStateFactory(),

      pageSize: 20,

      lastSearchQuery: '',
      totalServerItems: 1,
      currentMembership: false,
      getMembershipId: false,

      queryMembership: {
        salesChannels: 'pointOfSale',
        membershipLevelGroup: 'individualAndFamily',
        isPublished: 1
      },

      init: function() {
        $scope.$on('PosCreatePagesFormsController::Update', this.onPosCreatePagesFormsControllerUpdate);

        $scope.$watch('posCreatePagesFormsMembership.selected', this.onSelected);

        $scope.$watchCollection('posCreatePagesFormsMembership.colorCodes', this.onColorCodesUpdate);

        $scope.$on('destroy', function() {
          $timeout.cancel($scope.posCreatePagesFormsMembership.queryTimer);
        });
      },

      getMemberships: function (searchQuery) {
        var props;
        this.gridState.updateGridState(null, this.pageSize, 'name', 'asc');
        this.gridState.gridState.search = searchQuery || '';
        props = angular.extend(this.queryMembership, this.gridState.getGridState());
        props.summarize = '1';
        //Forcing this to -1 since membership levels api does not support search right now.
        props.pageSize = -1;
        ApiService.membership.categories.list(props).then(this.success.getMemberships, this.error.getMemberships);
      },

      getMembership: function(id) {
        ApiService.membership.categories.detail(id).then(this.success.getMembership, this.error.getMembership);
      },

      showAutoComplete: function(field) {

        var input = $('#'+field);

        this.reduceList = false;

        $timeout(function () {
          input.trigger('focus');
        }, 0);

      },

      hasSelected: function() {
        return (this.selected && typeof this.selected === 'object');
      },

      findMembership: function(id) {

        var i, ii,
            r = false;

        for (i=0,ii=this.list.length;i<ii;i++) {
          if (""+this.list[i].id === ""+id) {
            r = {
              membership: this.list[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      getTitle: function() {
        var r = 'Enter a title';
        if (this.selected && this.selected.name) {
          r = this.selected.name;
        }
        return r;
      },

      getSubTitle: function () {
        var r = 'Enter a subtitle';
        return r;
      },

      process: function (memberships, count) {
        var r = memberships,
            currentCount = (this.gridState.gridState.page || 1) * this.gridState.gridState.pageSize;

        //if there are more items for this search, show pagination
        if (count && count > currentCount) {
          this.showMore = {
            showMoreLabel: 'Show '+ this.pageSize +' more of ' + count,
            hasMore: true
          };
        } else {
          this.showMore = {
            showMoreLabel: '',
            hasMore: false
          };
        }

        return r;
      },

      remove: function() {
        $scope.$emit('PosCreatePagesFormsController::RemoveTile', this.model);
      },

      cancel: function() {
        $scope.$emit('PosCreatePagesFormsController::Cancel', this.model);
      },

      resetAddOn: function() {
        var foundMembership, self = $scope.posCreatePagesFormsMembership;
        $timeout(function() {
          //reset membership selected if no membership is chosen
          if (!self.hasSelected()) {
            foundMembership = self.findMembership(self.model.id);

            if (foundMembership || self.currentMembership) {
              self.selected = !foundMembership ? self.currentMembership : self.list[foundMembership.index];
            }
          }
          this.reduceList = false;
        },0);
      },

      search: function(field) {
        var props;
        this.searching = true;
        props = angular.extend(this.queryMembership, this.gridState.getGridState());
        props.summarize = '1';
        ApiService.membership.categories.list(props).then(function(response) {
          $scope.posCreatePagesFormsMembership.success.search(response, field);
        }, this.error.search);
      },

      filterList: function(force, field) {

        var timeoutMS = force ? 0 : 500;

        if (this.queryTimer) {
          $timeout.cancel(this.queryTimer);
        }

        this.queryTimer = $timeout(function () {
          var self = $scope.posCreatePagesFormsMembership;

          if (force || (typeof self.selected === 'string') && (self.lastSearchQuery !== self.selected)) {
            if (!force) {
              self.gridState.setPropertyValue('pageSize', self.pageSize);
            } else {
              self.gridState.setPropertyValue('pageSize', (self.gridState.gridState.pageSize + self.pageSize) );
            }
            self.gridState.gridState.search = self.hasSelected() ? '' : self.selected;
            self.lastSearchQuery = self.gridState.gridState.search;
            self.search(field);
          }
        }, timeoutMS);
      },

      showMoreResults: function(item) {
        switch(item.field) {
          case 'pos-create-pages-forms-membership-list': this.filterList(true, item.field);
            break;
        }
      },

      done: function () {
        this.model.name = '';

        if (this.title) {
          this.model.name = this.title;
        } else if (this.selected && this.selected.name) {
          this.model.name = this.selected.name;
        }

        if (this.selected) {
          this.model.id = this.selected.id;
        }

        this.model.icon = (this.showIcon) ? 'membership' : 'none';

        this.model.subTitle = this.subTitle;

        this.model.color = PosConfigService.tiles.toColor(this.color);
        if (!this.model.color.a) {
          this.model.color.a = 1;
        }
        this.model.type = 'membership';
        if (this.selected.price) {
          this.model.price = this.selected.price;
        }

        if (this.model.config.pageId) {
          this.model.config.pageId = null;
          delete this.model.config.pageId;
        }

        PosConfigService.updateTile(PosConfigService.pages.getSelectedPageId(), this.model);
        $scope.$emit('PosCreatePagesFormsController::UpdateTile');
      },

      success: {
        init: function(response) {},

        getMemberships: function (response) {
          var self = $scope.posCreatePagesFormsMembership;

          self.totalServerItems = response.data.payload.pagination.count;

          self.list = self.process(response.data.payload.list, self.totalServerItems);

          self.isLoaded = true;
        },

        getMembership: function (response) {
          var self = $scope.posCreatePagesFormsMembership;
          self.currentMembership = response.data.payload;
          self.selected = self.currentMembership;
          self.title = (self.model.name !== self.currentMembership.name) ? self.model.name : '';

          //only fetch the initial list once.
          self.getMemberships();
        },

        search: function(response, field) {
          var self = $scope.posCreatePagesFormsMembership;

          self.list = self.process(response.data.payload.list, response.data.payload.pagination.count);

          if (field) {
            $scope.$broadcast('CustomTypeahead::FilterResults', {field: field});
          }

        }
      },

      error: {
        init: function(response) {},
        getMemberships: function (response) {
          var self = $scope.posCreatePagesFormsMembership;
          self.totalServerItems = 0;
          self.list = [];
          self.isLoaded = true;
        },

        getMembership: function (response) {
          var self = $scope.posCreatePagesFormsMembership;
          self.currentMembership = false;
        },

        search: function(response, field) {
          var self = $scope.posCreatePagesFormsMembership;
          self.list = [];
        }
      },

      onSelected: function(n, o) {
        var self = $scope.posCreatePagesFormsMembership;

        if (self.hasSelected() && self.model.id == self.selected.id) {
          if (self.model.name && self.model.name.length) {
            self.title = (self.model.name !== self.selected.name) ? self.model.name : '';
          }else{
            self.title = '';
          }
          self.subTitle = self.model.subTitle;
        }else {
          self.title = '';
          self.subTitle = '';
        }
        if (self.hasSelected() &&
            (!self.subTitle || !self.subTitle.length) &&
            self.selected.auxiliary &&
            self.selected.membershipLevelCollection) {
          self.subTitle = self.selected.membershipLevelCollection[0].name;
        }

      },

      onPosCreatePagesFormsControllerUpdate: function(e, data) {
        var foundMembership,
            self = $scope.posCreatePagesFormsMembership;

        if (data.config.type === 'membership') {
          self.selected = '';

          self.model = data;
          // Force watcher change event by resetting color to black
          self.spectrumConfig.color = '#000000';
          self.color = PosConfigService.tiles.colorToRgb(self.model);
          // next tick
          $timeout(function () {
            self.spectrumConfig.color = self.color;
          }, 0);

          self.showIcon = (self.model.icon && self.model.icon !== 'none');

          if (self.model.id) {
            if (self.currentMembership.id !== self.model.id) {
              self.getMembership(self.model.id);
            } else {
              self.selected = self.currentMembership;
              self.title = (self.model.name !== self.currentMembership.name) ? self.model.name : '';
            }
          } else {
            self.currentMembership = false;
            self.getMemberships();
          }
        }
      },

      onColorCodesUpdate: function(n, o) {
        if (n && n !== o) {
          $scope.posCreatePagesFormsMembership.color = n.backgroundColor;
        }
      }

    };

    $scope.posCreatePagesFormsMembership.init();

}])
.filter('membershipLevelGroupLabel', [ 'MembershipService', function(MembershipService) {

  return function(name) {
    var i, ii,
        r = name;

    for (i=0,ii=MembershipService.membershipLevelGroups.length;i<ii;i++) {
      if (MembershipService.membershipLevelGroups[i].name === name) {
        r = MembershipService.membershipLevelGroups[i].label;
        break;
      }
    }

    return r;

  };
}]);